import { createFormAction } from "redux-form-saga";
import { push } from "react-router-redux";
import * as ActionTypes from "./constants";

export const logout = () => dispatch => dispatch({
  type: ActionTypes.USER_LOGOUT_REQUEST
});

export const login = (code, lang) => dispatch => dispatch({
  type: ActionTypes.USER_LOGIN_REQUEST,
  code,
  lang
});
export const sumbitSendInvest = createFormAction(ActionTypes.SEND_INVEST);

export const sumbitPerformWithdraw = createFormAction(ActionTypes.PERFORM_WITHDRAW);

export const clearErrorMessageFromUser = () => dispatch => dispatch({
  type: ActionTypes.CLEAR_ERROR_MESSAGE
});

export const deleteInvest = payload => dispatch => dispatch({
  type: ActionTypes.DELETE_INVEST_REQUEST,
  payload
});

export const cancelWithdraw = () => dispatch => dispatch({
  type: ActionTypes.CANCEL_WITHDRAW_REQUEST
});

export const getNotifications = () => dispatch => dispatch({
  type: ActionTypes.GET_NOTIFICATION_REQUEST
});

export const getDashboard = () => dispatch => dispatch({
  type: ActionTypes.GET_DASHBORD_REQUEST
});

export const getTickers = () => dispatch => dispatch({
  type: ActionTypes.GET_TICKERS_REQUEST
});

export const getTransactions = () => dispatch => dispatch({
  type: ActionTypes.GET_TRANSACTIONS_REQUEST
});

export const setMarketingEmailConsentInSettings = boolVal => dispatch => dispatch({
  type: ActionTypes.SET_EMAIL_REQUEST,
  boolVal
});

export const setLocale = locale => dispatch => {
	localStorage.hbcLang = locale;
  dispatch({ type: ActionTypes.SET_LOCALE_REQUEST, locale });
};

export const goToInvestPage = () => dispatch => {
  dispatch(push(`/${(localStorage.hbcLang?localStorage.hbcLang.toLowerCase():"en")}/invest/`))
}

export const goToDashboardPage = () => dispatch => {
  dispatch(push(`/${(localStorage.hbcLang?localStorage.hbcLang.toLowerCase():"en")}/dashboard/`))
}

export const goToAuthPage = (codeState) => dispatch => {
  dispatch(push(`/auth/${codeState}`))
}



// WEBPACK FOOTER //
// ./src/ducks/user/actions.js